import { render, staticRenderFns } from "./MortgageSummary.vue?vue&type=template&id=4ddc5b71"
import script from "./MortgageSummary.vue?vue&type=script&lang=js"
export * from "./MortgageSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports